export enum RoutePaths {
    Root = "/",

    Login = "login",
    VerifyTwoFactor = "verify-2fa",
    EntraLogin = "auth/entra/callback",

    Register = "register",
    RegisterAdmin = "register-admin",
    ThankYouForRegistration = "thank-you-for-registration",
    EmailConfirmed = "email-confirmed",
    RequestPasswordReset = "reset-password",
    ChangePassword = "change-password",
    FirstPasswordSetup = "set-password",
    CheckMailbox = "check-mailbox",
    AccountActivation = "activate",
    CatchAll = "*",

    Eula = "eula",
    LicenseActivation = "license-activation",
    LicensePending = "license-pending",

    Manual = "manual",

    UserProfile = "account-settings",

    Admin = "admin",
    AdminGroupList = "group/list",
    AdminGroupDetails = "group/:id",
    AdminUserCreate = "user/create",
    AdminUserList = "user/list",
    AdminUserEdit = "user/:id/edit",
    AdminDataSourcesList = "data-sources/list",
    AdminScheduler = "scheduler",
    AdminReportedIssues = "reported-issues",
    AdminPrompts = "prompts",
    AdminAppInfo = "app-info",
    AdminConfiguration = "configuration",
    AdminLogs = "logs",
    AdminStatistics = "statistics",
    AdminLicenseManagement = "license-management",

    Dashboard = "dashboard",
    Chat = "chat",
    ChatWithId = "chat/:id",
    UserDataSourcesList = "data-sources/list",
    DataSourceDocuments = "data-sources/:id/documents",
    DocumentView = "documents/view/:id",
    Payments = "payment/begin",
    PaymentSuccess = "payment/success",
    PaymentFailure = "payment/failure",

    OcrBatch = "ocr/batch",
    OcrBatchDetails = "ocr/batch/:id",
    OcrFileResultPreview = "ocr/batch/:batchId/preview/:fileId",
    TextTranslator = "text-translator",
    DocumentsDigitization = "digitization",
    DigitizationDetails = "digitization/document/:id",
    DigitizationEdition = "digitization/document/:id/edition",

    Index = "",
}

export const RouteHelpers = {
    documentsDigitization: (params?: URLSearchParams) => {
        const base = `/digitization`;
        return params ? `${base}?${params.toString()}` : base;
    },
    digitizationDetails: (id: number, params?: URLSearchParams) => {
        const base = `/digitization/document/${id}`;
        return params ? `${base}?${params.toString()}` : base;
    },
    digitizationEdition: (id: number) => {
        return `/digitization/document/${id}/edition`;
    },
};

export enum PageTitleKeys {
    Login = "Login",
    VerifyTwoFactor = "VerifyTwoFactor",
    EntraLogin = "EntraLogin",

    Register = "Register",
    ThankYouForRegistration = "ThankYouForRegistration",
    EmailConfirmed = "EmailConfirmed",
    RequestPasswordReset = "RequestPasswordReset",
    ChangePassword = "ChangePassword",
    FirstPasswordSetup = "FirstPasswordSetup",
    CheckMailbox = "CheckMailbox",
    AccountActivation = "AccountActivation",

    Eula = "Eula",
    LicenseActivation = "LicenseActivation",
    LicensePending = "LicensePending",
    Manual = "Manual",

    UserProfile = "UserProfile",

    AdminGroupList = "AdminGroupList",
    AdminGroupDetails = "AdminGroupDetails",
    AdminUserCreate = "AdminUserCreate",
    AdminUserList = "AdminUserList",
    AdminUserEdit = "AdminUserEdit",
    AdminDataSourcesList = "AdminDataSourcesList",
    AdminScheduler = "AdminScheduler",
    AdminReportedIssues = "AdminReportedIssues",
    AdminPrompts = "AdminPrompts",
    AdminAppInfo = "AdminAppInfo",
    AdminConfiguration = "AdminConfiguration",
    AdminLogs = "AdminLogs",
    AdminStatistics = "AdminStatistics",
    AdminLicenseManagement = "AdminLicenseManagement",

    Dashboard = "Dashboard",
    Chat = "Chat",
    ChatWithId = "ChatWithId",
    UserDataSourcesList = "UserDataSourcesList",
    DataSourceDocuments = "DataSourceDocuments",
    DocumentView = "DocumentView",
    Payments = "Payments",
    PaymentSuccess = "PaymentSuccess",
    PaymentFailure = "PaymentFailure",
    OcrBatch = "OCRBatch",
    OcrBatchDetails = "OCRBatchDetails",
    OcrFileResultPreview = "OCRFileResultPreview",
    TextTranslator = "TextTranslator",
    DocumentsDigitization = "DocumentsDigitization",
    DigitizationDetails = "DigitizationDetails",
    DigitizationEdition = "DigitizationEdition",

    Default = "Default",
    Home = "Home",
}

export const pageTitles: Record<PageTitleKeys, string> = {
    [PageTitleKeys.Login]: 'pageTitles.login',
    [PageTitleKeys.VerifyTwoFactor]: 'pageTitles.verifyTwoFactor',
    [PageTitleKeys.EntraLogin]: 'pageTitles.entraLogin',

    [PageTitleKeys.Register]: 'pageTitles.register',
    [PageTitleKeys.ThankYouForRegistration]: 'pageTitles.thankYouForRegistration',
    [PageTitleKeys.EmailConfirmed]: 'pageTitles.emailConfirmed',
    [PageTitleKeys.RequestPasswordReset]: 'pageTitles.requestPasswordReset',
    [PageTitleKeys.ChangePassword]: 'pageTitles.changePassword',
    [PageTitleKeys.FirstPasswordSetup]: 'pageTitles.FirstPasswordSetup',
    [PageTitleKeys.CheckMailbox]: 'pageTitles.checkMailbox',
    [PageTitleKeys.AccountActivation]: 'pageTitles.accountActivation',

    [PageTitleKeys.Eula]: 'pageTitles.eula',
    [PageTitleKeys.LicenseActivation]: 'pageTitles.licenseActivation',
    [PageTitleKeys.LicensePending]: 'pageTitles.licensePending',
    [PageTitleKeys.Manual]: 'pageTitles.manual',

    [PageTitleKeys.UserProfile]: 'pageTitles.userProfile',

    [PageTitleKeys.AdminGroupList]: 'pageTitles.adminGroupList',
    [PageTitleKeys.AdminGroupDetails]: 'pageTitles.adminGroupDetails',
    [PageTitleKeys.AdminUserCreate]: 'pageTitles.adminUserCreate',
    [PageTitleKeys.AdminUserList]: 'pageTitles.adminUserList',
    [PageTitleKeys.AdminUserEdit]: 'pageTitles.adminUserEdit',
    [PageTitleKeys.AdminDataSourcesList]: 'pageTitles.adminDataSourcesList',
    [PageTitleKeys.AdminScheduler]: 'pageTitles.adminScheduler',
    [PageTitleKeys.AdminReportedIssues]: 'pageTitles.adminReportedIssues',
    [PageTitleKeys.AdminPrompts]: 'pageTitles.adminPrompts',
    [PageTitleKeys.AdminAppInfo]: 'pageTitles.adminAppInfo',
    [PageTitleKeys.AdminConfiguration]: 'pageTitles.adminConfiguration',
    [PageTitleKeys.AdminLogs]: 'pageTitles.adminLogs',
    [PageTitleKeys.AdminStatistics]: 'pageTitles.adminStatistics',
    [PageTitleKeys.AdminLicenseManagement]: 'pageTitles.adminLicenseManagement',

    [PageTitleKeys.Dashboard]: 'pageTitles.dashboard',
    [PageTitleKeys.Chat]: 'pageTitles.chat',
    [PageTitleKeys.ChatWithId]: 'pageTitles.chatWithId',
    [PageTitleKeys.UserDataSourcesList]: 'pageTitles.userDataSourcesList',
    [PageTitleKeys.DataSourceDocuments]: 'pageTitles.dataSourceDocuments',
    [PageTitleKeys.DocumentView]: 'pageTitles.documentView',
    [PageTitleKeys.Payments]: 'pageTitles.payments',
    [PageTitleKeys.PaymentSuccess]: 'pageTitles.paymentSuccess',
    [PageTitleKeys.PaymentFailure]: 'pageTitles.paymentFailure',
    [PageTitleKeys.OcrBatch]: 'pageTitles.ocrBatch',
    [PageTitleKeys.OcrBatchDetails]: 'pageTitles.ocrBatch',
    [PageTitleKeys.OcrFileResultPreview]: 'pageTitles.ocrFileResultPreview',
    [PageTitleKeys.TextTranslator]: 'pageTitles.textTranslator',
    [PageTitleKeys.DocumentsDigitization]: 'pageTitles.documentsDigitization',
    [PageTitleKeys.DigitizationDetails]: 'pageTitles.digitizationDetails',
    [PageTitleKeys.DigitizationEdition]: 'pageTitles.digitizationEdition',

    [PageTitleKeys.Home]: 'pageTitles.home',
    [PageTitleKeys.Default]: 'pageTitles.default',
};

export const pageDescriptions: Record<PageTitleKeys, string> = {
    [PageTitleKeys.Login]: 'pageDescriptions.login',
    [PageTitleKeys.VerifyTwoFactor]: 'pageDescriptions.verifyTwoFactor',
    [PageTitleKeys.EntraLogin]: 'pageDescriptions.entraLogin',

    [PageTitleKeys.Register]: 'pageDescriptions.register',
    [PageTitleKeys.ThankYouForRegistration]: 'pageDescriptions.thankYouForRegistration',
    [PageTitleKeys.EmailConfirmed]: 'pageDescriptions.emailConfirmed',
    [PageTitleKeys.RequestPasswordReset]: 'pageDescriptions.requestPasswordReset',
    [PageTitleKeys.ChangePassword]: 'pageDescriptions.changePassword',
    [PageTitleKeys.FirstPasswordSetup]: 'pageDescriptions.firstPasswordSetup',
    [PageTitleKeys.CheckMailbox]: 'pageDescriptions.checkMailbox',
    [PageTitleKeys.AccountActivation]: 'pageDescriptions.accountActivation',

    [PageTitleKeys.Eula]: 'pageDescriptions.eula',
    [PageTitleKeys.LicenseActivation]: 'pageDescriptions.licenseActivation',
    [PageTitleKeys.LicensePending]: 'pageDescriptions.licensePending',
    [PageTitleKeys.Manual]: 'pageDescriptions.manual',

    [PageTitleKeys.UserProfile]: 'pageDescriptions.userProfile',

    [PageTitleKeys.AdminGroupList]: 'pageDescriptions.adminGroupList',
    [PageTitleKeys.AdminGroupDetails]: 'pageDescriptions.adminGroupDetails',
    [PageTitleKeys.AdminUserCreate]: 'pageDescriptions.adminUserCreate',
    [PageTitleKeys.AdminUserList]: 'pageDescriptions.adminUserList',
    [PageTitleKeys.AdminUserEdit]: 'pageDescriptions.adminUserEdit',
    [PageTitleKeys.AdminDataSourcesList]: 'pageDescriptions.adminDataSourcesList',
    [PageTitleKeys.AdminScheduler]: 'pageDescriptions.adminScheduler',
    [PageTitleKeys.AdminReportedIssues]: 'pageDescriptions.adminReportedIssues',
    [PageTitleKeys.AdminPrompts]: 'pageDescriptions.adminPrompts',
    [PageTitleKeys.AdminAppInfo]: 'pageDescriptions.adminAppInfo',
    [PageTitleKeys.AdminConfiguration]: 'pageDescriptions.adminConfiguration',
    [PageTitleKeys.AdminLogs]: 'pageDescriptions.adminLogs',
    [PageTitleKeys.AdminStatistics]: 'pageDescriptions.adminStatistics',
    [PageTitleKeys.AdminLicenseManagement]: 'pageDescriptions.adminLicenseManagement',

    [PageTitleKeys.Dashboard]: 'pageDescriptions.dashboard',
    [PageTitleKeys.Chat]: 'pageDescriptions.chat',
    [PageTitleKeys.ChatWithId]: 'pageDescriptions.chatWithId',
    [PageTitleKeys.UserDataSourcesList]: 'pageDescriptions.userDataSourcesList',
    [PageTitleKeys.DataSourceDocuments]: 'pageDescriptions.dataSourceDocuments',
    [PageTitleKeys.DocumentView]: 'pageDescriptions.documentView',
    [PageTitleKeys.Payments]: 'pageDescriptions.payments',
    [PageTitleKeys.PaymentSuccess]: 'pageDescriptions.paymentSuccess',
    [PageTitleKeys.PaymentFailure]: 'pageDescriptions.paymentFailure',
    [PageTitleKeys.OcrBatch]: 'pageDescriptions.ocrBatch',
    [PageTitleKeys.OcrBatchDetails]: 'pageDescriptions.ocrBatch',
    [PageTitleKeys.OcrFileResultPreview]: 'pageDescriptions.ocrFileResultPreview',
    [PageTitleKeys.TextTranslator]: 'pageDescriptions.textTranslator',
    [PageTitleKeys.DocumentsDigitization]: 'pageDescriptions.documentsDigitization',
    [PageTitleKeys.DigitizationDetails]: 'pageDescriptions.digitizationDetails',
    [PageTitleKeys.DigitizationEdition]: 'pageDescriptions.digitizationEdition',

    [PageTitleKeys.Home]: 'pageDescriptions.home',
    [PageTitleKeys.Default]: 'pageDescriptions.default',
};
